import { useEffect, useState } from 'react';
import { inflightRegistry } from '../../domain/services/upload/upload.inflight.registry';

export default function useUploadsInFlight() {
    const [count, setCount] = useState(inflightRegistry.count());

    useEffect(() => inflightRegistry.subscribe(setCount), []);

    return { inFlight: count > 0, count };
}
